import {NgModule} from '@angular/core';
import {NoPreloading, RouterModule, Routes} from '@angular/router';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import {AuthGuard} from './auth/auth.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'home',
        loadChildren: () => import('./home/home.module').then((x) => x.HomePageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'radars',
        loadChildren: () => import('./radars/radars.module').then((x) => x.RadarsPageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'rains',
        loadChildren: () => import('./rains/rains.module').then((x) => x.RainsPageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'events',
        loadChildren: () => import('./events/events.module').then((x) => x.EventsPageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then((x) => x.ProfilePageModule),
        canActivate: [AuthGuard],
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then((x) => x.LoginPageModule),
    },
    {
        path: 'logout',
        loadChildren: () => import('./logout/logout.module').then((x) => x.LogoutPageModule),
    },
    {path: '**', component: PageNotFoundComponent},
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {useHash: true, preloadingStrategy: NoPreloading}),
        // {preloadingStrategy: PreloadAllModules, useHash: true})
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
